import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type InsertSmsMessageMutationVariables = Types.Exact<{
  move_id: Types.Scalars['bigint']['input'];
  recipient_phone: Types.Scalars['String']['input'];
  sender_phone: Types.Scalars['String']['input'];
  message_body: Types.Scalars['String']['input'];
  direction: Types.Scalars['String']['input'];
  status: Types.Scalars['String']['input'];
  createdby?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type InsertSmsMessageMutation = { __typename?: 'mutation_root', insert_smsmessages_one?: { __typename?: 'smsmessages', id: number, move_id?: number | null, recipient_phone?: string | null, sender_phone?: string | null, message_body?: string | null, createdat?: string | null, updatedat?: string | null, status?: string | null, direction: string, createdby?: string | null } | null };


export const InsertSmsMessageDocument = gql`
    mutation insertSmsMessage($move_id: bigint!, $recipient_phone: String!, $sender_phone: String!, $message_body: String!, $direction: String!, $status: String!, $createdby: String) {
  insert_smsmessages_one(
    object: {move_id: $move_id, recipient_phone: $recipient_phone, sender_phone: $sender_phone, message_body: $message_body, direction: $direction, status: $status, createdby: $createdby}
  ) {
    id
    move_id
    recipient_phone
    sender_phone
    message_body
    createdat
    updatedat
    status
    direction
    createdby
  }
}
    `;
export type InsertSmsMessageMutationFn = Apollo.MutationFunction<InsertSmsMessageMutation, InsertSmsMessageMutationVariables>;

/**
 * __useInsertSmsMessageMutation__
 *
 * To run a mutation, you first call `useInsertSmsMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertSmsMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertSmsMessageMutation, { data, loading, error }] = useInsertSmsMessageMutation({
 *   variables: {
 *      move_id: // value for 'move_id'
 *      recipient_phone: // value for 'recipient_phone'
 *      sender_phone: // value for 'sender_phone'
 *      message_body: // value for 'message_body'
 *      direction: // value for 'direction'
 *      status: // value for 'status'
 *      createdby: // value for 'createdby'
 *   },
 * });
 */
export function useInsertSmsMessageMutation(baseOptions?: Apollo.MutationHookOptions<InsertSmsMessageMutation, InsertSmsMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertSmsMessageMutation, InsertSmsMessageMutationVariables>(InsertSmsMessageDocument, options);
      }
export type InsertSmsMessageMutationHookResult = ReturnType<typeof useInsertSmsMessageMutation>;
export type InsertSmsMessageMutationResult = Apollo.MutationResult<InsertSmsMessageMutation>;
export type InsertSmsMessageMutationOptions = Apollo.BaseMutationOptions<InsertSmsMessageMutation, InsertSmsMessageMutationVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/moves/mutations/insertSmsMessage.mutation.gql}
 */
export async function insertSmsMessage(
  variables: InsertSmsMessageMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<InsertSmsMessageMutation['insert_smsmessages_one']>
export async function insertSmsMessage(
  variables: InsertSmsMessageMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<InsertSmsMessageMutation>
export async function insertSmsMessage(
  variables: InsertSmsMessageMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<InsertSmsMessageMutation['insert_smsmessages_one'] | InsertSmsMessageMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<InsertSmsMessageMutation>(
    InsertSmsMessageDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.insert_smsmessages_one
}